import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { abbrNum } from '@src/shared/includes/functions';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

/**
 * Widget: RecordAgeInPath
 *
 * Displays information about how long records are sitting in the Action Path.
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function RecordAgeInPath({ data = {} }) {
  return (
    <ErrorHandler location="src/widgets/ActionPaths/RecordAgeInPath/RecordAgeInPath.jsx">
      <Widget description="How long records are sitting in the Action Path" title="Record Age In Path">
        <Layout.Group grow space={Number(themeConfiguration?.theme?.space?.xl) || 48}>
          <Box css={{ backgroundColor: 'var(--abyss-colors-success2)', padding: 'var(--abyss-space-lg)' }}>
            <Layout.Stack alignLayout="center">
              <Text>
                <small>Minimum Time</small>
              </Text>
              <Text>
                <strong>
                  {abbrNum(data?.minDays)} {abbrNum(data?.minDays) === 1 ? 'day' : 'days'}
                </strong>
              </Text>
            </Layout.Stack>
          </Box>
          <Box css={{ backgroundColor: 'var(--abyss-colors-warning2)', padding: 'var(--abyss-space-lg)' }}>
            <Layout.Stack alignLayout="center">
              <Text>
                <small>Average Time</small>
              </Text>
              <Text>
                <strong>
                  {abbrNum(data?.avgDays)} {abbrNum(data?.avgDays) === 1 ? 'day' : 'days'}
                </strong>
              </Text>
            </Layout.Stack>
          </Box>
          <Box css={{ backgroundColor: 'var(--abyss-colors-error2)', padding: 'var(--abyss-space-lg)' }}>
            <Layout.Stack alignLayout="center">
              <Text>
                <small>Minimum Time</small>
              </Text>
              <Text>
                <strong>
                  {abbrNum(data?.maxDays)} {abbrNum(data?.maxDays) === 1 ? 'day' : 'days'}
                </strong>
              </Text>
            </Layout.Stack>
          </Box>
        </Layout.Group>
      </Widget>
    </ErrorHandler>
  );
}
